import React, { useEffect } from 'react'
import Modal from 'antd/es/modal'
import Form from 'antd/es/form';
import Input from 'antd/es/input';
import Button from 'components/button'
import { CustomerContact } from 'models/customer'
import Notification from 'antd/es/notification'
import Space from 'antd/es/space';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { generateMongoId } from 'functions/generate-mongo-id'

type Props = {
  visible: boolean
  data: CustomerContact[] | undefined
  onSave: (data: CustomerContact[]) => void
  onCancel: () => void
}

export const ModifyContacts = (props: Props) => {

  const [form] = Form.useForm();

  const onFinish = (result: { contacts: CustomerContact[] }) => {
    try {

      const output: CustomerContact[] = []

      result.contacts.forEach(item => {
        if (!item._id) {
          item._id = generateMongoId()
        }
        output.push(new CustomerContact(item))
      })
      props.onSave(output)
      props.onCancel()

    } catch (e) {
      console.log(e)
      Notification.error({ message: JSON.stringify(e) })
    }
  };


  useEffect(() => {
    form.resetFields()
  }, [props.visible])

  return (
    <Modal
      visible={props.visible}
      title={'Lisää kontakti'}
      onCancel={() => { props.onCancel() }}
      closable={false}
      closeIcon={false}
      footer={
        <Button.ButtonGroup style={{ justifyContent: 'flex-end' }}>
          <Button
            label="Peruuta"
            onClick={() => { props.onCancel() }}
            color="default"
          />
          <Button
            label="Tallenna"
            onClick={() => {
              form.submit()
            }}
            color="green"
          />
        </Button.ButtonGroup>
      }
    >

      <Form
        form={form}
        name="basic"
        onFinish={onFinish}
        onFinishFailed={() => { }}
        autoComplete="off"
      >
        <Form.List name="contacts" initialValue={props.data}>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, fieldKey, ...restField }) => (
                <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                  <Form.Item
                    hidden={true}
                    {...restField}
                    name={[name, '_id']}
                    fieldKey={[fieldKey, '_id']}
                  >

                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, 'name']}
                    fieldKey={[fieldKey, 'name']}
                    rules={[{ required: true, message: 'Anna nimi' }]}
                  >
                    <Input placeholder="Nimi" />
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, 'email']}
                    fieldKey={[fieldKey, 'email']}
                  >
                    <Input placeholder="Sähköposti" />
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, 'job_title']}
                    fieldKey={[fieldKey, 'job_title']}
                  >
                    <Input placeholder="Työnimike" />
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, 'phone']}
                    fieldKey={[fieldKey, 'phone']}
                  >
                    <Input placeholder="Puhelinnumero " />
                  </Form.Item>
                  <MinusCircleOutlined onClick={() => remove(name)} />
                </Space>
              ))}
              <Form.Item>
                <Button label="Lisää kontakti" onClick={() => add()} icon={<PlusOutlined />} color="default-dashed" style={{ width: '100%', justifyContent: 'center' }} />
              </Form.Item>
            </>
          )}
        </Form.List>
      </Form>
    </Modal>
  )

}

export default ModifyContacts